import { RootState } from "../store";

export const selectMessagesModalFormErrors = (state: RootState) => state.modalFormErrors.messages;